import React from 'react';

type MyWaysToSaveIconProps = React.SVGProps<SVGSVGElement>;

const MyWaysToSaveIcon: React.FC<MyWaysToSaveIconProps> = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={19}
      height={17}
      viewBox="0 0 19 17"
      fill="none"
      {...props}
    >
      <path
        d="M1.13475 13.8652V6.01925V6.548V1.13475V13.8652ZM15.2172 16.0578L11.9865 12.827C11.7827 12.6232 11.6397 12.4074 11.5577 12.1798C11.4757 11.9523 11.4348 11.7231 11.4348 11.4923C11.4348 10.9974 11.6103 10.5577 11.9615 10.173C12.3128 9.7885 12.7661 9.59625 13.3212 9.59625C13.7557 9.59625 14.0968 9.6965 14.3443 9.897C14.5916 10.0977 14.8826 10.3653 15.2172 10.7C15.5314 10.3858 15.8148 10.1233 16.0673 9.9125C16.3199 9.70167 16.6687 9.59625 17.1135 9.59625C17.6852 9.59625 18.1425 9.79108 18.4855 10.1808C18.8285 10.5706 19 11.0129 19 11.5078C19 11.7384 18.9548 11.9692 18.8645 12.2C18.774 12.4308 18.6352 12.6398 18.448 12.827L15.2172 16.0578ZM1.13475 4.07125H17.8652V1.44225C17.8652 1.36542 17.8333 1.29492 17.7693 1.23075C17.7051 1.16675 17.6346 1.13475 17.5578 1.13475H1.44225C1.36542 1.13475 1.29492 1.16675 1.23075 1.23075C1.16675 1.29492 1.13475 1.36542 1.13475 1.44225V4.07125ZM8.75375 15H1.44225C1.05008 15 0.711667 14.8577 0.427 14.573C0.142333 14.2883 0 13.9499 0 13.5577V1.44225C0 1.05008 0.142333 0.711667 0.427 0.427C0.711667 0.142334 1.05008 0 1.44225 0H17.5578C17.9499 0 18.2883 0.142334 18.573 0.427C18.8577 0.711667 19 1.05008 19 1.44225V7.17125C18.4552 6.80575 17.8642 6.52242 17.227 6.32125C16.5898 6.11992 15.9199 6.01925 15.2172 6.01925C14.6866 6.01925 14.1661 6.07692 13.6557 6.19225C13.1456 6.30758 12.661 6.47358 12.202 6.69025H1.13475V13.5577C1.13475 13.6346 1.16675 13.7051 1.23075 13.7693C1.29492 13.8333 1.36542 13.8652 1.44225 13.8652H8.49575C8.52158 14.0651 8.55667 14.2603 8.601 14.4508C8.64517 14.6413 8.69608 14.8243 8.75375 15Z"
        fill="white"
      />
    </svg>
  );
};

export default MyWaysToSaveIcon;
